import api from './api';

const vacacionesService = {
  // Obtener solicitudes según rol
  async getSolicitudes(usuarioID, rol) {
    try {
      const response = await api.get(`/vacaciones?usuarioID=${usuarioID}&rol=${rol}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener solicitudes:', error);
      throw error;
    }
  },

  // Crear nueva solicitud
  async crearSolicitud(datos) {
  try {
    // ✅ Normalizar nombres de campos para el backend
    const payload = {
      empleadoID: datos.empleadoId,  // Backend espera empleadoID
      fechaInicio: datos.fechaInicio,
      fechaFin: datos.fechaFin,
      dias: datos.dias,
      diasHabiles: datos.diasHabiles || datos.dias,
      motivo: datos.motivo,
      tipo: datos.tipo || 'vacaciones'
    };
    
    const response = await api.post('/vacaciones', payload);
    return response.data;
  } catch (error) {
    console.error('Error al crear solicitud:', error);
    throw error;
  }
},

  // Crear solicitud con períodos múltiples
  async crearSolicitudConPeriodos(datos) {
  try {
    // ✅ Normalizar nombres de campos
    const payload = {
      empleadoId: datos.empleadoId,  // Este endpoint usa empleadoId (camelCase)
      fechaInicio: datos.fechaInicio,
      fechaFin: datos.fechaFin,
      dias: datos.dias,
      diasHabiles: datos.diasHabiles || datos.dias,
      motivo: datos.motivo,
      tipo: datos.tipo || 'vacaciones',
      periodosSeleccionados: datos.periodosSeleccionados
    };
    
    const response = await api.post('/vacaciones/con-periodos', payload);
    return response.data;
  } catch (error) {
    console.error('Error al crear solicitud con períodos:', error);
    throw error;
  }
},

  // Procesar solicitud (aprobar/rechazar)
  // Procesar solicitud (aprobar/rechazar)
async procesarSolicitud(solicitudId, datos) {
  try {
    // ✅ CAMBIO: La ruta correcta es /vacaciones/aprobar
    const response = await api.post('/vacaciones/aprobar', {
      solicitudID: solicitudId,
      usuarioID: datos.usuarioID || datos.aprobadorId,  // Asegurar que envía usuarioID
      accion: datos.accion,
      esManual: datos.esManual,
      motivo: datos.motivoManual || datos.motivo || ''
    });
    return response.data;
  } catch (error) {
    console.error('Error al procesar solicitud:', error);
    throw error;
  }
},

  // Obtener estadísticas del empleado (simple)
  async getEstadisticas(empleadoId, anio = null) {
    try {
      const url = anio 
        ? `/vacaciones/estadisticas/${empleadoId}?anio=${anio}`
        : `/vacaciones/estadisticas/${empleadoId}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
      throw error;
    }
  },

  // Obtener estadísticas detalladas con períodos
  async getEstadisticasDetalladas(empleadoId) {
    try {
      const response = await api.get(`/vacaciones/estadisticas-detalladas/${empleadoId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas detalladas:', error);
      throw error;
    }
  },

  // Asignar días manualmente (solo RRHH)
  async asignarDias(empleadoId, anio, dias) {
    try {
      const response = await api.post('/vacaciones/asignar-dias', {
        empleadoId,
        anio,
        dias
      });
      return response.data;
    } catch (error) {
      console.error('Error al asignar días:', error);
      throw error;
    }
  },

  // Obtener detalles de una solicitud específica
  async getSolicitudById(solicitudId) {
    try {
      const response = await api.get(`/vacaciones/${solicitudId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener solicitud:', error);
      throw error;
    }
  },

  // Crear solicitud con entrada manual (ya aprobada)
async crearSolicitudManual(datos) {
  try {
    const payload = {
      empleadoID: datos.empleadoID || datos.empleadoId,
      fechaInicio: datos.fechaInicio,
      fechaFin: datos.fechaFin,
      dias: datos.dias,
      diasHabiles: datos.diasHabiles || datos.dias,
      motivo: datos.motivo,
      tipo: datos.tipo || 'vacaciones'
    };
    
    const response = await api.post('/vacaciones/entrada-manual', payload);
    return response.data;
  } catch (error) {
    console.error('Error al crear solicitud manual:', error);
    throw error;
  }
}
,

  // Días por designación (ferias, misiones)
  async getMisDesignaciones(empleadoId) {
    const response = await api.get(`/vacaciones/designaciones/empleado/${empleadoId}`);
    return response.data;
  },

  async getDesignaciones(filtros = {}) {
    const response = await api.get('/vacaciones/designaciones', { params: filtros });
    return response.data;
  },

  async crearDesignacion(datos) {
    const response = await api.post('/vacaciones/designaciones', datos);
    return response.data;
  },

  // Plantilla Excel con todos los colaboradores activos y la columna "Días a otorgar"
  async descargarPlantillaDesignaciones() {
    let res;
    try {
      res = await api.get('/vacaciones/designaciones/plantilla', { responseType: 'blob' });
    } catch (e) {
      // Con responseType 'blob' el error del backend llega como Blob: se convierte a JSON para poder mostrarlo
      const data = e.response?.data;
      if (data instanceof Blob) {
        try { e.response.data = JSON.parse(await data.text()); } catch { /* se deja tal cual */ }
      }
      throw e;
    }
    const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', 'plantilla-designaciones.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  },

  // Lee el Excel y devuelve { colaboradores, errores, totalErrores } sin registrar nada
  async leerExcelDesignaciones(archivo) {
    const formData = new FormData();
    formData.append('archivo', archivo);
    const response = await api.post('/vacaciones/designaciones/leer-excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async habilitarDesignacion(id) {
    const response = await api.put(`/vacaciones/designaciones/${id}/habilitar`);
    return response.data;
  },

  async anularDesignacion(id) {
    const response = await api.put(`/vacaciones/designaciones/${id}/anular`);
    return response.data;
  },

  // Recordatorio de solicitudes pendientes a los líderes (RRHH)
  async getVistaPreviaRecordatorios() {
    const response = await api.get('/vacaciones/recordatorios/vista-previa');
    return response.data;
  },

  async enviarRecordatorios(correoPrueba) {
    const response = await api.post('/vacaciones/recordatorios/enviar', correoPrueba ? { correoPrueba } : {});
    return response.data;
  },

  // Días feriados: [{ id, fecha: 'YYYY-MM-DD', descripcion }]
  async getFeriados(desde, hasta) {
    const response = await api.get('/vacaciones/feriados', { params: { desde, hasta } });
    return response.data;
  },

  async crearFeriado(fecha, descripcion) {
    const response = await api.post('/vacaciones/feriados', { fecha, descripcion });
    return response.data;
  },

  async eliminarFeriado(id) {
    const response = await api.delete(`/vacaciones/feriados/${id}`);
    return response.data;
  },

  // Ventana de 30 días del permiso de cumpleaños del usuario
  async getMiCumpleanos() {
    const response = await api.get('/vacaciones/cumpleanos/mi-estado');
    return response.data;
  }

};

export default vacacionesService;
